import ProgressBar from '@ramonak/react-progress-bar';
import React from 'react';
import { Bounce } from 'react-reveal';



const Skills = () => {
    return (
        <div id='skills' className='bg-[#1f1f38] text-white lg:pt-0 sm:pt-24'>
            <div className="flex flex-col">

                <h2 className="text-3xl font-bold text-center">
                    My Expertise Area
                </h2>
                <div className="flex lg:flex-row justify-center lg:px-20 py-20 sm:flex flex-col sm:px-0">
                    <Bounce left>
                        <div className="lg:w-2/4 mx-10 sm:w-full shadow-xxl px-5 py-5">
                            <h4 className="font-semibold">HTML5</h4>
                            <ProgressBar completed={95} className="mb-2" />
                            <h4 className="font-semibold">CSS3</h4>
                            <ProgressBar completed={87} className="mb-2" />
                            <h4 className="font-semibold">Javascript(ES6)</h4>
                            <ProgressBar completed={83} className="mb-2" />
                            <h4 className="font-semibold">Bootstrap</h4>
                            <ProgressBar completed={93} className="mb-2" />
                            <h4 className="font-semibold">ReactJs</h4>
                            <ProgressBar completed={85} className="mb-2" />
                        </div>
                    </Bounce>
                    <Bounce right >
                        <div className="lg:w-2/4 mx-10 sm:w-full shadow-xl px-5 py-5">
                            <h4 className="font-semibold">NodeJs</h4>
                            <ProgressBar completed={66} className="mb-2 " />
                            <h4 className="font-semibold">Exoress</h4>
                            <ProgressBar completed={69} className="mb-2" />
                            <h4 className="font-semibold">MongoDB</h4>
                            <ProgressBar completed={75} className="mb-2" />
                            <h4 className="font-semibold">TailWind</h4>
                            <ProgressBar completed={85} className="mb-2" />
                            <h4 className="font-semibold">Material UI</h4>
                            <ProgressBar completed={80} className="mb-2" />
                        </div>
                    </Bounce>
                </div>
            </div>
        </div>
    );
};


export default Skills;